import { IEnvironment } from './interfaces/environment.interface';

export const environment: IEnvironment = {
  isMock: false,
  enableProdMode: false,
};
